import PersonPhoto from './PersonPhoto';

export default PersonPhoto;
